var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconhide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.89121 13.514C2.68329 13.2167 2.57178 12.8627 2.57178 12.5C2.57178 12.1372 2.68329 11.7832 2.89121 11.486C4.23949 9.57711 7.55921 5.64282 12.0001 5.64282C16.4409 5.64282 19.7606 9.57711 21.1089 11.486C21.3168 11.7832 21.4283 12.1372 21.4283 12.5C21.4283 12.8627 21.3168 13.2167 21.1089 13.514C19.7606 15.4228 16.4409 19.3571 12.0001 19.3571C7.55921 19.3571 4.23949 15.4228 2.89121 13.514Z",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 15.9287C13.8934 15.9287 15.4284 14.3937 15.4284 12.5001C15.4284 10.6066 13.8934 9.07153 11.9999 9.07153C10.1063 9.07153 8.57129 10.6066 8.57129 12.5001C8.57129 14.3937 10.1063 15.9287 11.9999 15.9287Z",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42871 21.0713L20.5716 3.92847",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconhide);
export default __webpack_public_path__ + "static/media/icon hide.23804a5200159db9e4be780f5896e2e9.svg";
export { ForwardRef as ReactComponent };